/**
 * InsightHelper help OKM team analytic user search event and send request to csknowledgeinsightserv
 * 1. Tracking the auto-complete/full search response
 * 2. Tracking the click event, if user clicks one of the auto-complete/full search response
 */
import axios from 'axios';

const SEARCH_ANALYTICS_URL = '/smarthelp/insight-analytics-search';
const CLICK_ANALYTICS_URL = '/smarthelp/insight-analytics-click';

const searchType = {
  autoComplete: 'auto-complete',
  fullSearch: 'full-search',
};

// Get the number of full search result
const getFullSearchCount = response => (Array.isArray(response) ? response.length : 0);

// Get the number of auto complete with docid
const getAutoSearchCount = (response) => {
  let counter = 0;

  if (!Array.isArray(response)) {
    return counter;
  }

  response.forEach((autoSuggest) => {
    if (autoSuggest && !!autoSuggest.docid) {
      counter += 1;
    }
  });

  return counter;
};

// Parsing Search request body; param = { count, type, query }
const searchParser = (params = {}) => {
  const requestBody = {
    _csrf: params.csrf,
    type: params.type || 'search',
    count: params.count || 0,
    query: params.query,
  };

  return requestBody;
};


// Parsing Click request body; param = { type, articleId, articleTitle, rank, query }
const clickParser = (params = {}) => {
  const requestBody = {
    _csrf: params.csrf,
    type: params.type || 'search',
    articleId: params.articleId,
    articleTitle: params.articleTitle,
    rank: params.rank,
    query: params.query,
  };

  return requestBody;
};

// full/auto-complete Search result analytics
const searchAnalytics = (requestBody = {}) =>
  axios.post(SEARCH_ANALYTICS_URL, requestBody)
    .catch((error) => { console.warn('searchAnalytics error: ', error); });

// full/auto-complete click event analytics
const clickAnalytics = (requestBody = {}) =>
  axios.post(CLICK_ANALYTICS_URL, requestBody)
    .catch((error) => { console.warn('clickAnalytics error: ', error); });

module.exports = {
  searchType,
  getFullSearchCount,
  getAutoSearchCount,
  searchParser,
  clickParser,
  searchAnalytics,
  clickAnalytics,
};
